export const SOFTLINE_API_CHECKLISTE_ENTITIES = '/v1/aufgabe/entities';
export const SOFTLINE_API_CHECKLISTE_CHECKPUNKTE = '/v1/aufgabe/{{idaufgabe}}/check/entities';
